import { trackAdClick } from './trackClick';

/**
 * Carte marque d'un partner_block : fond couleur + logo + nom + sous-titre.
 * La couleur de fond (bg_color) est contrôlée par l'annonceur via l'admin.
 * Le texte est forcé en blanc avec ombre portée discrète pour préserver
 * le contraste WCAG AA quelle que soit la teinte choisie.
 */
export default function BrandCard({ adId, brand }) {
  const handleClick = (e) => {
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) {
      trackAdClick(adId, { itemType: 'brand' });
      return;
    }
    e.preventDefault();
    trackAdClick(adId, { itemType: 'brand' });
    window.open(brand.click_url, '_blank', 'noopener,noreferrer');
  };

  const bg = brand.bg_color || '#D4183D';

  return (
    <a
      href={brand.click_url}
      onClick={handleClick}
      rel="sponsored nofollow noopener"
      target="_blank"
      aria-label={`Visiter ${brand.name} — lien sponsorisé, nouvel onglet`}
      className="group flex flex-col justify-between rounded-md p-4 md:p-5 text-white no-underline min-h-[220px] h-full transition-transform duration-300 hover:-translate-y-0.5 motion-reduce:transition-none motion-reduce:transform-none focus:outline-none focus:ring-2 focus:ring-white/70 focus:ring-offset-2"
      style={{ backgroundColor: bg, textShadow: '0 1px 2px rgba(0,0,0,0.15)' }}
    >
      {brand.logo_url ? (
        <img
          src={brand.logo_url}
          alt={`Logo ${brand.name}`}
          width={120}
          height={48}
          loading="lazy"
          decoding="async"
          className="h-12 w-auto object-contain self-start"
        />
      ) : (
        <span className="text-[10px] uppercase tracking-wider text-white/70">Marque</span>
      )}

      <div className="flex flex-col gap-1 mt-4">
        <div className="font-bold text-lg leading-tight">{brand.name}</div>
        {brand.subtitle && (
          <div className="text-xs md:text-sm text-white/90 leading-snug">{brand.subtitle}</div>
        )}
      </div>

      <span className="inline-flex items-center gap-1 text-xs font-semibold mt-3 group-hover:gap-2 transition-all motion-reduce:transition-none">
        Visiter <span aria-hidden="true">→</span>
      </span>
    </a>
  );
}
